import React from "react";
import { Marker } from "react-leaflet";

import L, { Icon, IconOptions, LatLng } from 'leaflet';

import './MyLocationMarker.css';

interface MyLocationMarkerParams {
    myLocation: LatLng | undefined
}

const MyLocationMarker: React.FC<MyLocationMarkerParams> = ({ myLocation }) => {

    const provideIcon = (): Icon<IconOptions> => {
        return L.icon({
            className: "my-location-marker",
            iconSize: [30, 30],
            // iconAnchor: [13, 40],
            // popupAnchor: [0, -40],
            iconUrl: '/icons/location/location_my_icon.svg',
        })
    }

    return (
        myLocation && (
            <>
                <Marker
                    position={myLocation}
                    autoPan
                    icon={provideIcon()}
                />
            </>
        )
    )
}

export default MyLocationMarker